import _Object$assign from 'babel-runtime/core-js/object/assign';
import _extends from 'babel-runtime/helpers/extends';

import TargetLabel from './TargetLabel.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    TargetLabel: TargetLabel
  },
  data: function data() {
    return {
      currentNode: null
    };
  },
  props: {
    treeProps: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    currentNodeKey: {
      default: null
    },
    popDisabled: {
      type: Boolean,
      default: false
    },
    imageStyle: {
      type: Object,
      default: function _default() {
        return {
          width: '20px',
          height: '20px'
        };
      }
    },
    // 支持El-schema-form动态组件
    config: {
      type: Object
    },
    model: {
      type: Object
    }
  },
  computed: _extends({}, mapGetters({
    currentSceneTree: 'workspace/game/currentSceneTree'
  }), {
    isElSchemaForm: function isElSchemaForm() {
      return this.config && this.model;
    },
    currentValue: function currentValue() {
      if (this.isElSchemaForm) {
        if (!this.model[this.config.prop]) return null;
        return this.model[this.config.prop][this.computedTreeProps.nodeKey];
      }
      return this.currentNodeKey;
    },
    computedTreeProps: function computedTreeProps() {
      var defaultProps = {
        data: this.currentSceneTree,
        props: {
          children: 'children',
          label: 'name'
        },
        highlightCurrent: true,
        nodeKey: 'uuid'
      };
      return _Object$assign(defaultProps, this.treeProps);
    }
  }),
  methods: {
    handleCurrentChange: function handleCurrentChange(node) {
      this.currentNode = node;
      this.$emit('select', node);
      if (this.isElSchemaForm) {
        if (this.config.handler) {
          this.$emit('update-field', {
            prop: this.config.prop,
            value: this.config.handler(node)
          });
        } else {
          this.$emit('update-field', { prop: this.config.prop, value: node });
        }
      }
    }
  }
};